import type { ProductVariationBase, SelectedProductVariation } from 'models/productsReferential';
import { DataById, FormFieldId } from 'state/formData/formData.model';
import { Thunk } from 'state/state.common';
import { essentialWorkspaceTabActions } from 'state/workspaces/essential/actions';
import { getWorkspaceEssentialTabQuoteId } from 'state/workspaces/essential/selectors';
import {
  workspaceTabPersistRequested,
  workspaceTabProductSelectionSubmitted,
} from 'state/workspaces/workspace.actions';
import { essentialWorkspaceShowTabsPanelChanged } from 'state/workspaces/workspaces/workspace.actions';
import { getSelectedClient } from 'state/workspaces/workspaces/workspaces.selector';

export function toggleEssentialWorkspaceUnderlyingResultThunk(tabId: string): Thunk<void> {
  return dispatch => {
    dispatch(essentialWorkspaceTabActions.toggleUnderlyingsResult(tabId));
    dispatch(workspaceTabPersistRequested(tabId, 'essential'));
  };
}

export function toggleEssentialWorkspacePayoffGraphThunk(tabId: string): Thunk<void> {
  return dispatch => {
    dispatch(essentialWorkspaceTabActions.togglePayoffGraph(tabId));
    dispatch(workspaceTabPersistRequested(tabId, 'essential'));
  };
}

export function toggleEssentialWorkspaceTabsPanel(tabId: string): Thunk<void> {
  return dispatch => {
    dispatch(essentialWorkspaceShowTabsPanelChanged());
    dispatch(workspaceTabPersistRequested(tabId, 'essential'));
  };
}

export function submitProductSelectionEssentialWorkspaceThunk(
  tabId: string,
  product: ProductVariationBase,
): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    const client = getSelectedClient(state, 'essential');
    dispatch(workspaceTabProductSelectionSubmitted(tabId, product as SelectedProductVariation, client, 'essential'));
    dispatch(workspaceTabPersistRequested(tabId, 'essential'));
  };
}

export function synchronizeWorkspaceProductVariationWithFormValuesThunk(formId: string, values: DataById): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    const existingVariation = state.workspaces.essential[formId]?.productVariation;
    const existingProductSubtype = existingVariation?.productSubtype;
    const existingWrapper = existingVariation?.wrapper;

    const productSubtype = values['ProductSubtype' satisfies FormFieldId] as string | undefined;
    const productType = values['ProductType' satisfies FormFieldId] as string | undefined;
    const wrapper = (values['Wrapper' satisfies FormFieldId] as string | undefined) ?? existingWrapper;

    if (
      existingVariation?.productType !== productType ||
      existingProductSubtype !== productSubtype ||
      existingWrapper !== wrapper
    ) {
      dispatch(
        essentialWorkspaceTabActions.updateProductVariation(
          formId,
          productType && productSubtype && wrapper ? { productType, productSubtype, wrapper } : undefined,
        ),
      );
      dispatch(workspaceTabPersistRequested(formId, 'essential'));
    }
  };
}

export function essentialTabSetAssociatedQuoteThunk(tabId: string, quoteId: string): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    const oldQuoteId = getWorkspaceEssentialTabQuoteId(state, tabId);
    if (quoteId !== oldQuoteId) {
      dispatch(essentialWorkspaceTabActions.setQuote(tabId, quoteId));
      dispatch(workspaceTabPersistRequested(tabId, 'essential'));
    }
  };
}
